import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Tooltip,
  Dialog,
  DialogContent,
  Drawer,
  useMediaQuery,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import GroupIcon from "@mui/icons-material/Group";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuth } from "../context/AuthContext";
import stsnlogo from "../assets/images/stsnlogo.png"
import logo from "../assets/images/stsnlogo.png";
import leaf from "../assets/images/leaf.png";
import FormComponent from "../pages/Userprofile";
import { districtTamilNames } from "../utils/formDataUtils";

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const location = useLocation();
  const [openDialog, setOpenDialog] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isMobile = useMediaQuery("(max-width:768px)");

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
    setDrawerOpen(false); // close drawer after navigation
  };

  const pathParts = location.pathname.split("/");
  const currentDistrict = pathParts[1] || null;

  const isActive = (path) => location.pathname.startsWith(path);

  const activeStyle = { fontSize: 24, color: "#E52029" };
  const defaultStyle = { fontSize: 24, color: "#57511F" };
  const iconStyle = { fontSize: 24, color: "#57511F" };
  const logoSize = isMobile ? 48 : 70;
  const titleFontSize = isMobile ? "16px" : "22px";

  const districtTamil =
    currentDistrict && districtTamilNames[currentDistrict]
      ? districtTamilNames[currentDistrict]
      : currentDistrict;

  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: "#FAD707" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {/* Logo + Title (Always visible) */}
          {!user ? (
            <>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img
                  src={stsnlogo}
                  alt="இடது லோகோ"
                  style={{ width: `${logoSize}px`, height: `${logoSize}px` }}
                />
              </Box>

              <Box
                sx={{
                  textAlign: "center",
                  fontWeight: 600,
                  fontSize: titleFontSize,
                  color: "#E52029",
                  lineHeight: 1.2,
                  px: 1,
                  flex: 1,
                }}
              >
                தமிழ்நாடு சேனைத்தலைவர் மகாஜன சங்கம்
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img
                  src={leaf}
                  alt="வலது லோகோ"
                  style={{ width: `${logoSize}px`, height: `${logoSize}px` }}
                />
              </Box>
            </>
          ) : (
            <>
              {currentDistrict ? (
                <>
                  {/* Left Logo + District */}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={logo}
                      alt="சங்கத்தின் லோகோ"
                      style={{ width: `${logoSize}px`, height: `${logoSize}px` }}
                    />
                    <Box
                      sx={{
                        color: "#E52029",
                        fontWeight: 600,
                        textAlign: "left",
                        fontSize: titleFontSize,
                        ml: 1,
                        lineHeight: 1.2,
                      }}
                    >
                      {districtTamil} மாவட்ட சேனைத்தலைவர் சங்கம்
                    </Box>
                  </Box>

                  {/* Right side */}
                  {isMobile ? (
                    // Mobile → Show Drawer Toggle
                    <IconButton onClick={() => setDrawerOpen(true)}>
                      <MenuIcon sx={{ fontSize: 28, color: "#57511F" }} />
                    </IconButton>
                  ) : (
                    // Desktop → Show Inline Icons
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Tooltip title="உறுப்பினர் அட்டை">
                        <IconButton onClick={() => handleNavigate(`/${currentDistrict}/membership`)}>
                          <AccountCircleIcon
                            sx={isActive(`/${currentDistrict}/membership`) ? activeStyle : defaultStyle}
                          />
                        </IconButton>
                      </Tooltip>

                      {(user?.role === "superuser" || user?.role === "admin") && (
                        <Tooltip title="பயனர்களை மேலாண்மை செய்யவும்">
                          <IconButton onClick={() => handleNavigate(`/${currentDistrict}/manageusers`)}>
                            <GroupIcon
                              sx={isActive(`/${currentDistrict}/manageusers`) ? activeStyle : defaultStyle}
                            />
                          </IconButton>
                        </Tooltip>
                      )}

                      <Tooltip title="வெளியேறு">
                        <IconButton onClick={logout}>
                          <LogoutIcon sx={iconStyle} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                </>
              ) : (
                // No district → Default Tamil Nadu Title + Logos
                <>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={logo}
                      alt="இடது லோகோ"
                      style={{ width: `${logoSize}px`, height: `${logoSize}px` }}
                    />
                  </Box>

                  <Box
                    sx={{
                      textAlign: "center",
                      fontWeight: 600,
                      fontSize: titleFontSize,
                      color: "#E52029",
                      lineHeight: 1.2,
                      px: 1,
                      flex: 1,
                    }}
                  >
                    தமிழ்நாடு சேனைத்தலைவர் மகாஜன சங்கம்
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={leaf}
                      alt="வலது லோகோ"
                      style={{ width: `${logoSize}px`, height: `${logoSize}px` }}
                    />
                  </Box>
                </>
              )}
            </>
          )}
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile Menu */}
      {/* Drawer for Mobile Menu */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: { width: 260, backgroundColor: "#fdfbe9", p: 2 },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          {/* Membership */}
          <Box
            onClick={() => handleNavigate(`/${currentDistrict}/membership`)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
              color: isActive(`/${currentDistrict}/membership`) ? "#E52029" : "#57511F",
              fontSize: "18px",
              fontWeight: 500,
              "&:hover": { color: "#E52029" },
            }}
          >
            <AccountCircleIcon
              sx={isActive(`/${currentDistrict}/membership`) ? activeStyle : defaultStyle}
            />
            உறுப்பினர் அட்டை
          </Box>

          {/* Manage Users */}
          {(user?.role === "superuser" || user?.role === "admin") && (
            <Box
              onClick={() => handleNavigate(`/${currentDistrict}/manageusers`)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                cursor: "pointer",
                color: isActive(`/${currentDistrict}/manageusers`) ? "#E52029" : "#57511F",
                fontSize: "18px",
                fontWeight: 500,
                "&:hover": { color: "#E52029" },
              }}
            >
              <GroupIcon
                sx={isActive(`/${currentDistrict}/manageusers`) ? activeStyle : defaultStyle}
              />
              பயனர்களை மேலாண்மை செய்யவும்
            </Box>
          )}

          {/* Logout */}
          <Box
            onClick={logout}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
              color: "#57511F",
              fontSize: "18px",
              fontWeight: 500,
              "&:hover": { color: "#E52029" },
            }}
          >
            <LogoutIcon sx={iconStyle} />
            வெளியேறு
          </Box>
        </Box>
      </Drawer>


      {/* Add User Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#f8f9e9",
            borderRadius: 2,
            boxShadow: 3,
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "black",
            backdropFilter: "blur(4px)",
          },
        }}
      >
        <DialogContent>
          <FormComponent onClose={() => setOpenDialog(false)} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Header;
